import React, { useState } from "react";
import { useSubmitProductFeedbackMutation } from "../../../redux-toolkit/features/auth/authApiSlice";
import "./FeedbackModal.css";

const FeedbackModal = ({
  isOpen,
  onClose,
  userName,
  userEmail,
  userRole,
  page,
  onSuccess,
  onError,
}) => {
  const [rating, setRating] = useState(0);
  const [text, setText] = useState("");
  const [loading, setLoading] = useState(false);
  const [submitProductFeedback] = useSubmitProductFeedbackMutation();

  const handleResetForm = () => {
    setRating(0);
    setText("");
    onClose();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const pageUrl = typeof window !== "undefined" ? window.location.href : page;
    try {
      const data = await submitProductFeedback({
        name: userName || "",
        email: userEmail || "",
        rating,
        feedback: text,
        role: userRole || "",
        page: pageUrl || "",
      }).unwrap();
      setLoading(false);
      handleResetForm();
      onSuccess(data?.data || { result: true });
    } catch (err) {
      setLoading(false);
      onError(err);
    }
  };

  if (!isOpen) return null;

  const ratingPercent = (rating / 5) * 100;

  return (
    <>
      <div
        className="feedback-modal__backdrop"
        onClick={handleResetForm}
        aria-hidden="true"
      />
      <div
        id="feedbackModal"
        className="feedback-modal__wrapper"
        role="dialog"
        aria-modal="true"
        aria-labelledby="feedback-modal-title"
      >
        <div
          className="feedback-modal__card"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="feedback-modal__header">
            <h3 id="feedback-modal-title" className="feedback-modal__title">
              Feedback
            </h3>
            <button
              type="button"
              onClick={handleResetForm}
              className="feedback-modal__close"
              aria-label="Close modal"
            >
              <svg
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 14 14"
                className="feedback-modal__close-icon"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                />
              </svg>
            </button>
          </div>

          <div className="feedback-modal__divider" />

          <form onSubmit={handleSubmit} className="feedback-modal__form">
            <div className="feedback-modal__form-section">
              <label
                htmlFor="feedback-rating"
                className="feedback-modal__label"
              >
                How likely are you to recommend us to a friend or colleague?
              </label>
              <div className="feedback-modal__slider-wrap">
                <input
                  id="feedback-rating"
                  type="range"
                  min="0"
                  max="5"
                  step="1"
                  value={rating}
                  onChange={(e) => setRating(Number(e.target.value))}
                  className="feedback-modal__slider"
                  style={{ "--rating-percent": `${ratingPercent}%` }}
                />
                <div className="feedback-modal__slider-labels">
                  <span>0</span>
                  <span>1</span>
                  <span>2</span>
                  <span>3</span>
                  <span>4</span>
                  <span>5</span>
                </div>
                <div className="feedback-modal__slider-captions">
                  <span>Not likely at all</span>
                  <span>Extreme Likely</span>
                </div>
              </div>
            </div>

            <div className="feedback-modal__divider" />

            <div className="feedback-modal__form-section">
              <label
                htmlFor="feedback-message"
                className="feedback-modal__label"
              >
                What is the primary reason for your score?
              </label>
              <textarea
                id="feedback-message"
                value={text}
                onChange={(e) => setText(e.target.value)}
                placeholder="Type your message here..."
                rows={4}
                className="feedback-modal__textarea"
              />
            </div>

            <div className="feedback-modal__actions">
              <button
                type="button"
                onClick={handleResetForm}
                className="feedback-modal__btn feedback-modal__btn--skip"
              >
                Skip
              </button>
              <button
                type="submit"
                className="feedback-modal__btn feedback-modal__btn--send"
                disabled={loading}
              >
                {loading ? "Sending..." : "Send"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default FeedbackModal;
